import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-sand py-10 sm:py-14" aria-labelledby="guarantee-heading" data-id="element-78" data-mp="4uqdmw6js2tb">
      <div className="mx-auto w-full max-w-2xl px-5 sm:px-8" data-id="element-79" data-mp="9ttjgiucqd2c">
        <div className="flex flex-col items-center rounded-3xl border border-gold/30 bg-ivory p-6 text-center sm:p-9" data-id="element-80" data-mp="9wfrskp2gwlm">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-cream" data-id="element-81" data-mp="jsipnecvy92r">
            <ShieldCheckIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-82" data-mp="nu4b3o3hjvok" />
          </span>
          <h2 id="guarantee-heading" className="mt-4 font-serif text-[1.25rem] font-semibold uppercase leading-tight text-ink sm:text-3xl" data-id="element-83" data-mp="nrrmwt74wp32">
            7-Day Satisfaction Guarantee
          </h2>
          <p className="mt-3 max-w-md text-[0.9rem] leading-relaxed text-muted sm:text-base" data-id="element-84" data-mp="12jtezr2yqdsj">
            Explore the complete system and decide whether it fits the way you teach. If it isn’t
            right for you, request a refund within 7 days.
          </p>
        </div>
      </div>
    </section>;
}